import { render, staticRenderFns } from "./gift-card-view.vue?vue&type=template&id=68c693c3&scoped=true&"
import script from "./gift-card-view.vue?vue&type=script&lang=js&"
export * from "./gift-card-view.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-view.vue?vue&type=style&index=0&id=68c693c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c693c3",
  null
  
)

export default component.exports